"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldInlineDescriptionEditor = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
const InlineDescriptionEditor_1 = require("../InlineDescriptionEditor");
function FieldInlineDescriptionEditor(props) {
    const apiRequests = (0, catalog_core_1.useApiRequests)();
    const setDescription = (inputText) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (props.fieldType === 'HierarchyField') {
            const fieldArgs = {
                fullyQualifiedFieldName: props.fullyQualifiedFieldName,
                datasourceLuid: props.datasourceLuid,
                description: inputText,
            };
            return yield apiRequests.setDrillPathFieldDescription(fieldArgs);
        }
        const args = {
            fullyQualifiedFieldName: props.fullyQualifiedFieldName,
            datasourceLuid: props.datasourceLuid,
            description: inputText,
        };
        return yield apiRequests.setFieldDescription(args);
    });
    return (react_1.default.createElement(InlineDescriptionEditor_1.InlineDescriptionEditor, { canEdit: props.canEditDescription, onSave: setDescription, initialDescription: props.description, afterSave: props.afterDescriptionChange }));
}
exports.FieldInlineDescriptionEditor = FieldInlineDescriptionEditor;
//# sourceMappingURL=FieldInlineDescriptionEditor.js.map